import React from 'react';
import { InvoiceData, HospitalInfo } from './types';
import { getTemplateComponent } from './TemplateRegistry';

interface InvoiceRendererProps {
  invoice: InvoiceData;
  hospital: HospitalInfo;
  templateId: string;
}

export default function InvoiceRenderer({ invoice, hospital, templateId }: InvoiceRendererProps) {
  const TemplateComponent = getTemplateComponent(templateId);
  
  return <TemplateComponent invoice={invoice} hospital={hospital} />;
}
